<template>
    <div>
        <div class="row">

            <!-- INICIO DOS CAMPOS DO CADASTRO DO ACOLHIMENTO -->

            <form-select 
                label="Origem da Solicitação" 
                :itens="$root.arrays.acolhimento_origem_solicitacao" 
                v-model="item.origem_solicitacao_id" 
                grid="6"
                :required="true" 
            />
            <form-select 
                label="Unidade solicitante" 
                :itens="unidades"
                v-model="item.unidade_solicitante" 
                grid="6"
                :required="true" 
            />
            <form-select 
                label="Serviço socioassistencial" 
                :itens="servicos"
                v-model="item.servico_socioassistencial_id" 
                :required="true" 
                grid="6"
            />
            <form-input
                label="Nome completo do usuário"
                v-model="item.nome_acolhido"
                :required="true"
                grid="6"
            />
            <form-input 
                label="Nome social" 
                v-model="item.nome_social"
                grid="6"
            />
            <form-input 
                label="Data de nascimento" 
                v-model="item.nascimento" 
                type="date"
                grid="6"
            />
            <form-input 
                label="Número do CPF" 
                v-model="item.cpf" 
                v-mask="'###.###.###-##'"
                grid="6"
            />
            <form-select 
                label="Pessoa com deficiência?" 
                :itens="[{ id: null, value: 'Selecione' }, ...pergunta]" 
                v-model="item.deficiencia" 
                :required="true" 
                grid="6"
            />
            <form-input 
                label="Tipo de Deficiência" 
                v-model="item.tipo_deficiencia" 
                :required="mostrarDeficiencia"
                v-show="mostrarDeficiencia"
                grid="6"
            />
            <form-select 
                label="Gênero" 
                :itens="genero" 
                v-model="item.genero_id" 
                :required="true"
                grid="6"
            />
            <form-select 
                label="Família com presença de criança(s) e/ou adolescente(s)?" 
                :itens="$root.arrays.membros_na_familia" 
                v-model="item.familia_membros" 
                :required="true" 
                :multiple="true"
                grid="6"
            />
            <form-select 
                label="Pessoa em situação de rua?" 
                :itens="pergunta" 
                v-model="item.situacao_rua"
                :required="true"
                grid="6"
            />
            <form-input 
                label="Termo Acolhimento"
                v-model="item.termo_acolhimento"
                grid="6"
            />
            <form-calendar 
                label="Data do Acolhimento" 
                v-model="item.data_acolhimento" 
                :required="true" 
                :max-date="dataNow"
                grid="6"
            />
            <form-calendar 
                label="Horário" 
                v-model="item.hora_acolhimento" 
                mode="time"
                grid="6"
            />
            <form-select 
                label="Motivo(s) do Acolhimento:" 
                :itens="$root.arrays.motivos_acolhimento" 
                v-model="item.motivo_acolhimento" 
                :required="true" 
                :multiple="true"
                grid="12"
            />
            <form-input 
                type="text" 
                v-model="item.desc_motivo_acolhimento"  
                label="Descreva o Motivo(s) do Acolhimento:" 
                :required="mostrarMotivoAcolhimento"
                v-show="mostrarMotivoAcolhimento"
                grid="12"
            />

            <!-- FINAL DOS CAMPOS REFERENTE AO CADASTRO DO ACOLHIMENTO -->

            <form-select
                grid="6"
                label="Reincidência de acolhimento na unidade?"
                v-model="item.reincidencia"
                :itens="$root.arrays.reincidencia_acolhimento"
                :required="true"
            />
            <form-calendar
                grid="6"
                label="Data do ultimo acolhimento"
                v-show="mostrarDataUltimoAcolhimento"
                v-model="item.data_reincidencia"
                :max-date="dataNow"
            />
            <form-input
                label="Especifique Outros ou Negligência"
                v-if="item.motivo == 19 || item.motivo == 18"
                v-model="item.motivo_outros"
            />
            <form-select
                label="Criança/ adolescente incluído no Cadastro Nacional da Criança ou Adolescente Desaparecido?"
                v-model="item.crianca_cadastro_desaparecida"
                :itens="$root.arrays.pergunta"
                :required="true"
            />
            <form-select
                label="Criança/adolescente está incluído no Cadastro Nacional de Adoção?"
                v-model="item.crianca_cadastro_adocao"
                :itens="$root.arrays.pergunta"
                :required="true"
            />
            <form-select
                label="Adolescente cumprindo Medida Socioeducativa?"
                v-model="item.cumprimento_medidas"
                :itens="$root.arrays.pergunta"
                :required="true"
            />
            <form-select
                v-if="item.cumprimento_medidas == 1"
                ref="selectMedida"
                label="Qual Medida Socioeducativa?"
                v-model="item.tipo_medida"
                :itens="medidas"
                @search="procurarMedidas"
                :loading="loadingMedidas"
                :required="true"
            />
            <form-select
                label="Criança/Adolescente foi acolhida anteriormente?"
                v-model="item.acolhido_anteriomente"
                :itens="$root.arrays.pergunta"
                :required="true"
            />
            <form-select
                label="Medida protetiva de acolhimento institucional aplicada"
                v-model="item.medida_protetiva_aplicada"
                :itens="$root.arrays.medida_protetiva_aplicada"
                :required="true"
            />
        </div>
        <div class="row" v-if="item.medida_protetiva_aplicada > 1">
            <form-input
                grid="6"
                v-model="item.medida_nome_unidade"
                label="Nome da Unidade"
            />
            <form-input
                grid="6"
                v-model="item.medida_endereco"
                label="Endereço da Unidade"
            />
            <form-calendar
                grid="6"
                v-model="item.medida_data_entrada"
                label="Data de Entrada "
            />
            <form-calendar
                grid="6"
                v-model="item.medida_data_saida"
                label="Data de Saída"
            />
            <form-input
                v-model="item.medida_motivo_desligamento"
                label="Motivo do Desligamento"
            />
            <form-input
                v-model="item.nome_parentesco_guarda"
                label=" Nome e parentesco da pessoa que assumiu a guarda após o desligamento"
            />
        </div>
        <div class="row">
            <form-select
                label="Considerando os motivos do acolhimento, informe quem é / ou são o(s) suposto(s) autor(es) da violência/violação de direitos ou responsável(is) que está(ão) impossibilitado(s) de prestar os cuidados e proteção necessários à criança/adolescente?"
                v-model="item.autores_violencia_violacao"
                :itens="$root.arrays.autores_violencia_violacao"
                :required="true"
                :multiple="true"
            />
            <form-input
                v-if="item.autores_violencia_violacao == 11"
                v-model="item.autores_violencia_violacao_outro"
                label="Qual?"
            />
            <form-select
                label="Foram aplicadas outras medidas de proteção antes do acolhimento?"
                v-model="item.medidas_antes_acolhimento"
                :itens="$root.arrays.pergunta"
            />
            <form-select
                v-if="item.medidas_antes_acolhimento == 1"
                v-model="item.autores_violencia_violacao_outro"
                :itens="$root.arrays.medidas_antes_aplicadas"
                :multiple="true"
                label="Qual?"
            />
            <form-select
                v-model="item.impedimento_judicial"
                :itens="$root.arrays.pergunta"
                :required="true"
                label="Há impedimento judicial que impeça o contato dos pais/responsáveis com a criança/adolescente? "
            />
            <form-input-tag
                v-if="item.impedimento_judicial == 1"
                v-model="item.pessoas_impedidas"
                label="Se sim, indique as pessoas impedidas (Aperte ENTER, para inserir uma ou mais pessoas)"
            />
            <form-textarea-editor
                label="Observação sobre o acolhimento"
                v-model="item.observacao"
            />
            <form-select
                v-model="item.status"
                label="Status"
                grid="4"
                :itens="status"
                :loading="loadingStatus"
            />
            <!-- <form-select
				v-model="item.status"
				label="Status"
				grid="4"
				:itens="$root.arrays.acolhimento_status"
			/> -->
            <form-file
                grid="8"
                @submit="submitFile"
                multiple
                btn-text="Iniciar"
                :progress="progressCompleted"
            />
        </div>
        <search-tecnico
            v-if="carregouTecnicos"
            :key="keyTecnicos"
            :tecnicos.sync="item.tecnicos"
        />
        <div class="row pt-4 px-0 d-flex justify-content-end">
            <form-toggle
                grid="4"
                class="d-flex justify-content-end"
                mt="0"
                v-model="item.privado"
                label="Sigilo?"
            />
            <div class="col-auto px-2 text-right">
                <button
                    class="btn btn-success btn-submit"
                    @click="$emit('submit')"
                >
                    <i class="mdi mdi-content-save" />
                    {{ $t("Salvar") }}
                </button>
            </div>
        </div>
        <anexos :anexos="item.anexos" />
    </div>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            dataNow: moment().format("YYYY/MM/DD"),
            loadingMedidas: false,
            loadingStatus: false,
            medidas: [],
            unidades: [],
            servicos: [],
            files: "",
            status: "",
            progressCompleted: 0,
            pergunta: this.$root.arrays.pergunta,
            genero: this.$root.arrays.genero,
            dependencia: this.$root.arrays.acolhimento_grau_dependencia,
            tecnicos: {},
            tecnicos_selected: null,
            tecnico_temp: "",
            unidade: "",
            loading_tecnicos: false,
            carregouTecnicos: false,
            keyTecnicos: 0,
        };
    },
    watch: {
        item(n, o) {
            this.getMedida(this.item.tipo_medida, "id");
        },
        'item.reincidencia'(novoValor) {
            if (novoValor !== 1) {
                this.item.data_reincidencia = null; // ou "" se preferir string vazia
            }
        },
        'item.deficiencia'(novoValor) {
            if (Number(novoValor?.id ?? novoValor) !== 1) {
                this.item.tipo_deficiencia = null;
            }
        },
    },
    computed: {
        mostrarDataUltimoAcolhimento () {
            return this.item.reincidencia === 1;
        },
        mostrarDeficiencia() {
            const deficiencia = this.item.deficiencia;

            return Number(deficiencia?.id ?? deficiencia) === 1;
        },
        mostrarMotivoAcolhimento() {
            const motivo = this.item.motivo_acolhimento;

            if (!Array.isArray(motivo)) return false;

            return motivo.some(opcao => opcao === 19 || opcao.id === 19);
        },
    },
    mounted() {
        this.getStatus();
        this.getMedida(this.item.tipo_medida, "id");
        this.getUnidades();
        this.getServicos();
        this.prepararTecnicos();

        if (
            this.item.deficiencia === null ||
            this.item.deficiencia === undefined ||
            this.item.deficiencia === 0 ||
            this.item.deficiencia === "0"
        ) {
            this.item.deficiencia = null;
        } else {
            this.item.deficiencia = Number(this.item.deficiencia);
        }

       if (!Array.isArray(this.item.motivo_acolhimento)) {
            if (typeof this.item.motivo_acolhimento === "string") {
                try {
                    this.item.motivo_acolhimento = JSON.parse(this.item.motivo_acolhimento);
                } catch (e) {
                    this.item.motivo_acolhimento = [];
                }
            } else {
                this.item.motivo_acolhimento = [];
            }
        }

        // Converter valores para números
        this.item.motivo_acolhimento = this.item.motivo_acolhimento.map(Number);

        if (this.item.desc_motivo_acolhimento == "null") {

            this.item.desc_motivo_acolhimento = "";
            
        }

    },
    methods: {

        prepararTecnicos() {
            if (!this.item.tecnicos) {
                this.item.tecnicos = [];
            }

            if (typeof this.item.tecnicos === "string") {
                try {
                    this.item.tecnicos = JSON.parse(this.item.tecnicos);
                } catch (e) {
                    this.item.tecnicos = [];
                }
            }

            if (!Array.isArray(this.item.tecnicos)) {
                this.item.tecnicos = [];
            }

            this.item.tecnicos = this.item.tecnicos
                .map((tecnico) => {
                    if (typeof tecnico === "object" && tecnico !== null) {
                        return Number(tecnico.id);
                    }

                    return Number(tecnico);
                })
                .filter((tecnico) => !isNaN(tecnico));

            this.carregouTecnicos = true;
            this.keyTecnicos++;
        },

        getServicos() {
            axios.get(`api/dashboard/atendimento/servicos`).then((response) => {
                this.servicos = response.data;
            });
        },

        getUnidades() { 
            this.load = true;
            axios.get("api/dashboard/unidades-interna-externa").then((response) => {
                this.unidades = response.data.data.map((item) => ({
                    id: item.id,
                    value: item.descricao
                }));
            });
        },

        submitFile(files) {
            this.files = files;
            let formData = new FormData();
            for (const i of Object.keys(this.item)) {
                formData.append(i, this.item[i]);
            }
            // 	if (i == "anexos") {
            if (this.files.length > 0 && this.files.length != undefined) {
                for (const i of Object.keys(this.files)) {
                    formData.append("files[]", this.files[i]);
                }
            } else {
                formData.append("files", this.files);
            }
            // this.$emit("files", files);
            axios
                .post(`api/dashboard/acolhimento/upload`, formData, {
                    header: { "Content-Type": "multipart/form-data" },
                    onUploadProgress: (event) => {
                        let progress = Math.round(
                            (event.loaded * 100) / event.total
                        );
                        this.progressCompleted = progress;
                    },
                })
                .finally(() => {
                    this.$emit("submit");
                    this.progressCompleted = 0;
                });
        },
        getMedida(search, tipo = "termo") {
            axios
                .get(
                    `api/dashboard/acolhimento/pesquisar/medidas?q=${escape(
                        search
                    )}&tipo=${tipo}`
                )
                .then((response) => {
                    this.medidas = response.data;
                    this.$refs.selectMedida.openOptions(true);
                })
                .finally(() => {
                    this.$refs.selectMedida.closeOptions(false);
                    setTimeout(() => {
                        this.loadingMedidas = false;
                        if (tipo != "id") {
                            this.$refs.selectMedida.openOptions(true);
                        }
                    }, 3000);
                });
        },
        procurarMedidas: function procurarMedidas(search) {
            if (search != "") {
                clearTimeout(procurarMedidas.timeout);
                procurarMedidas.timeout = setTimeout(() => {
                    this.loadingMedidas = true;
                    this.$refs.selectMedida.openOptions(false);
                    this.getMedida(search);
                }, 1000);
            }
        },
        getStatus() {
            this.loadingStatus = true;
            axios
                .get(`api/dashboard/status/acolhimento`)
                .then((response) => {
                    this.status = response.data;
                })
                .finally(() => {
                    this.loadingStatus = false;
                });
        },
    },
};
</script>
